import { Chip, IconButton, makeStyles, Typography } from '@material-ui/core';

import { TableCellProps } from './types';

import { primaryColor } from 'src/data/colors';

const useStyles = makeStyles({
  chip: {
    color: 'white',
    margin: '5px',
  },
  icon: {
    height: '15px',
    width: '15px',
    '&:hover': {
      background: 'none',
      color: primaryColor,
    },
  },
  typography: {
    fontSize: '14px',
  },
});

const TableCell: React.FC<TableCellProps> = ({ actions, chipsColor, column, id, row }) => {
  const classes = useStyles();
  let value = row[column.id];

  if (column.formatData && typeof column.formatData === 'function') {
    value = column.formatData(value);
  }

  if (column.action && actions?.length) {
    return (
      <>
        {actions.map(({ Icon, action }, index) => (
          <IconButton className={classes.icon} disableRipple key={index} onClick={() => action(id)}>
            <Icon />
          </IconButton>
        ))}
      </>
    );
  }

  if (column.chip && Array.isArray(value)) {
    return (
      <>
        {value.map((val: string, index: number) => {
          const chipColor = chipsColor?.find((chip) => chip.value === val);
          return (
            <Chip
              className={classes.chip}
              key={index}
              label={val}
              style={{ backgroundColor: chipColor?.color }}
            />
          );
        })}
      </>
    );
  }

  return <Typography className={classes.typography}>{value}</Typography>;
};

export default TableCell;
